import { render, staticRenderFns } from "./ProvideAccess.html?vue&type=template&id=57b3c4b1&"
import script from "./ProvideAccess.js?vue&type=script&lang=js&"
export * from "./ProvideAccess.js?vue&type=script&lang=js&"
import style0 from "./ProvideAccess.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports